export const l_bullseye = {
  ".pf-l-bullseye": {
    "l_bullseye_Padding": {
      "name": "--pf-l-bullseye--Padding",
      "value": "0"
    }
  }
};
export default l_bullseye;